import Component from '../../../shared/component';
import RemoteReloadingElement from '../../../shared/components/remote-reloading-element';
import Popover from '../popover';

const REPLACE_HTML_DELAY = 400;

export default class GroupSuggestions extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$contentElement = this.$element.find('.groupSuggestions-content');
    this.$button = this.$element.find('.groupSuggestions-button');

    this.isFetchingNextGroups = false;
    this.shouldFetchNextGroups = true;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$button.on('click.GroupSuggestions', this.handleClick);
  }

  unbindEvents() {
    this.$button.off('click.GroupSuggestions', this.handleClick);

    if (this.popovers) {
      this.popovers.forEach((popover) => popover.unbindEvents());
    }

    if (this.remoteReloadingElements) {
      this.remoteReloadingElements.forEach((element) => element.unbindEvents());
    }
  }

  fetchNextGroups() {
    this.isFetchingNextGroups = true;

    $.get(this.$element.attr('action')).done((data) =>
      this.handleNextGroupsSuccess(data)
    );
  }

  replaceNextGroups(html) {
    this.$contentElement.addClass('groupSuggestions-content--hidden');

    setTimeout(() => {
      this.$contentElement.html(html);
      this.$contentElement.removeClass('groupSuggestions-content--hidden');
      this.isFetchingNextGroups = false;
      this.reapplyComponentBehavior();
    }, REPLACE_HTML_DELAY);
  }

  reapplyComponentBehavior() {
    this.popovers = Popover.initialize(this.$element.find('.popover'));
    this.remoteReloadingElements = RemoteReloadingElement.initialize(
      this.$element.find('.remoteReloadingElement')
    );
  }

  handleClick() {
    if (this.shouldFetchNextGroups && !this.isFetchingNextGroups) {
      this.fetchNextGroups();
    }
  }

  handleNextGroupsSuccess(data) {
    if (String(data).trim() !== '') {
      this.replaceNextGroups(data);
    } else {
      // The API returned an empty response so we hide the button
      this.$button.hide();
      this.shouldFetchNextGroups = false;
    }
  }
}
